import { useEffect, useState, useContext } from 'react';
import { NavContext } from '@components/navigation/Context';
import Colors from '@components/shared/Colors';
import { loadRecurly } from '@utils/loadScripts';
import loadRecurlyCSS from '../../../../recurly';

const useRecurlyLoaded = () => {
  const { navDispatch } = useContext(NavContext);
  const [recurlyLoaded, setRecurlyLoaded] = useState(false);

  useEffect(() => {
    navDispatch({ type: 'setColor', data: Colors.navyBlue });
    navDispatch({ type: 'setShowingBanner', data: false });
    loadRecurlyCSS();

    const checkRecurlyLoaded = async () => {
      await loadRecurly();
      if (window.recurly && window.recurly.Recurly) {
        setRecurlyLoaded(true);
      } else {
        // If not loaded, check again after a delay
        setTimeout(checkRecurlyLoaded, 200);
      }
    };

    checkRecurlyLoaded();
  }, [navDispatch]);

  return recurlyLoaded; // Return the loading state if needed
};

export default useRecurlyLoaded;
